import { render } from "./LargeNotificationItem.vue?vue&type=template&id=47fedec2&scoped=true&ts=true"
import script from "./LargeNotificationItem.vue?vue&type=script&lang=ts"
export * from "./LargeNotificationItem.vue?vue&type=script&lang=ts"

import "./LargeNotificationItem.vue?vue&type=style&index=0&id=47fedec2&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fedec2"]])

export default __exports__